<router-outlet></router-outlet>

<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.28)" size="medium" color="#fff" type="ball-beat" [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
